export function resetFileInput(e) {
  e.persist();
  e.target.value = '';
}
